<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { UserIsMemberOfEnterprises } from '@/js/enterPriseApi'
export default {
  name: 'App',

  created () {
    if (sessionStorage.getItem('ucStore')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('ucStore'))
        )
      )
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('ucStore', JSON.stringify(this.$store.state))
    })
  },
  mounted(){
    console.log('app.vue')
    //this.getEnterPrises();
  },
  methods:{
    
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
  /* overflow: hidden; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue